import React from 'react';
import { Trans } from '@lingui/macro';

import Button from '@src/components/Button';
import Container from '@src/components/Container';
import Separator from '@src/components/Separator';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { CheckAccess } from '@src/helpers/hasAccessMember';
import useAllStatus from '@src/hooks/useAllStatus';

import { Content, ScrollView, Title, UnlinkIcon } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = ({ navigation }) => {
  const hasPrime = CheckAccess(useAllStatus()) > 0;
  const handlePrimeLibraryPress = React.useCallback(
    () => navigation.navigate('PrimeLibrary'),
    [navigation]
  );

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <ScrollView>
          <UnlinkIcon />
          <Separator />
          <Title>
            <Trans>Can not connect to server</Trans>
          </Title>
          <Content>
            <Trans>
              Please make sure you have proper internet connection and try again
            </Trans>
          </Content>
          <Separator />
          {hasPrime && (
            <Button
              icon="book"
              mode="contained"
              onPress={handlePrimeLibraryPress}
            >
              <Trans>Go to Prime Library</Trans>
            </Button>
          )}
        </ScrollView>
      </Container>
    </>
  );
};

Screen.displayName = 'Offline';

export default Screen;
